import {ROOT_URL} from '@/store';

const REQUEST_LINK = '/iapi_report/build_report_page/?page_uid=';

import downloadBLOB from '@/assets/downloadBLOB';

function downloadPageExcelFile(pageUid, formData, handler) {
  fetch(ROOT_URL + REQUEST_LINK + pageUid, {
    method: 'POST',
    credentials: 'include',
    body: JSON.stringify(formData),
  }).then(async function(response) {
    if (response.status == 200) {
      let filename = response.headers.get('Content-Disposition');
      filename = filename.split(/;(.+)/)[1].split(/=(.+)/)[1];
      if (filename.toLowerCase().startsWith('utf-8\'\'')) filename = decodeURIComponent(filename.replace(/utf-8''/i, ''));
      else filename = filename.replace(/['"]/g, '');

      // filename = filename.match(/filename[^;=\n]*=(.*['"](.*)|(.*))/);
      // console.log('filename', filename);
      // filename = filename[2].replace('"', '');

      filename = decodeURI(filename);

      const blobFile = await response.blob();
      const url = window.URL.createObjectURL(blobFile);

      downloadBLOB(url, filename);

      handler('ok');
      return;
    }

    if (response.status == 401) {
      const dsData = await response.json();

      const authResult = await window.openExtAuthWindow(dsData.uid, dsData.view);
      if (authResult == 'ok') {
        downloadPageExcelFile(pageUid, formData, handler);
        return;
      }

      handler('error');
      return;
    }

    handler('error');
  }).catch((errData) => {
    handler('error');
  });
}

export default downloadPageExcelFile;
